import { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import useSetShareUser from './hooks/useSetShareUser'
interface IModalProps {
    show: boolean
    onHide: () => void
    user: IMoneyPoolResults | undefined
    refetch?: () => void
}
export default function ChangeShareModal({
    show,
    onHide,
    user,
    refetch,
}: IModalProps) {
    const { id } = useParams()
    const [value, setValue] = useState<string>('')
    const { mutate } = useSetShareUser(refetch)
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" w-full text-center py-4 text-sm px-4">
                <p className=" mb-3">
                    تعداد سهم های {user?.member.first_name}{' '}
                    {user?.member.last_name} را تعیین کنید
                </p>
                <input
                    type="text"
                    inputMode="numeric"
                    className=" outline-none border-1 border-gray-5 rounded-md w-full py-2.5 text-center"
                    onChange={(e) => setValue(e.target.value)}
                    value={value}
                    min={0}
                />
                <hr className=" my-3" />
                <p
                    className=" text-center text-green-1"
                    onClick={() => {
                        if (user) {
                            const payload: IChangeShareSettingPayload = {
                                moneyPool: id,
                                poolShip: user?.id,
                                share: Number(value),
                                role: user.role,
                            }
                            mutate(payload)
                            onHide()
                        }
                    }}
                >
                    تایید
                </p>
            </div>
        </Modal>
    )
}
